import axios from 'axios'
import { exportAxios } from '@/utils/axiosType'
export default {
  // 获取发票列表
  getReceipts (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/queryReceipts', params)
  },
  // 发票确认收款
  confirmInvoice (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/confirmReceivables', params)
  },
  // 修改发票状态备注
  updateFinanceRemark (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/updateFinanceRemark', params)
  },
  // 发票修改状态
  changeInvoicStatus (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/changeReceiptStatus', params)
  },
  // 预算科目查询
  getBudgetInfos (params) {
    return axios.post('/api/rendering/admin/base/budget/queryBudgetInfos', params)
  },
  // 公司部门查询
  getCompanyAndOrgs (params) {
    return axios.post('/api/rendering/admin/base/budget/queryCompanyAndOrgs', params)
  },
  // 公司部门查询
  getManagerByOrg (params) {
    return axios.post('/api/rendering/admin/base/budget/queryManagerByOrg', params)
  },
  // 导出发票列表
  exportInvoiceList (params) {
    return exportAxios('/api/rendering/admin/front/user/receipt/exportReceipts', params)
  },
  // 发票修改备注
  updateReceipt (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/updateReceipt', params)
  },
}
